import { render, staticRenderFns } from "./NewsFeed.vue?vue&type=template&id=2e2deb33&scoped=true"
import script from "./NewsFeed.vue?vue&type=script&lang=js"
export * from "./NewsFeed.vue?vue&type=script&lang=js"
import style0 from "./NewsFeed.vue?vue&type=style&index=0&id=2e2deb33&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2deb33",
  null
  
)

export default component.exports